import { LookupTransformer } from "@eres/ejari-api/IApi";
import { Lookup, LookupLike } from "@eres/ejari-api/Entity";

const OwnerCommitteeLookupTransformer: LookupTransformer = ( input: LookupLike ) => {
	return {
		ar: input.nameAr,
		en: input.nameEn,
		Id: input.identity,
		parentId: input.parentId,
	} as Lookup;
};

export { OwnerCommitteeLookupTransformer };